<template>
<!-- v-loading.fullscreen.lock:遮罩 fixed 只盖视口且锁 body 滚动,避免长容器 absolute 遮罩滚动后盖住顶部导航 -->
  <div class="authentication" v-loading.fullscreen.lock="pageLoading">
    <!-- 顶部审核状态提示(非首次认证显示:审核中/拒绝原因/状态文案) -->
    <div class="state-box" v-if="!notSubmitted">
      <div v-if="companyDetailData.auditStatus == 0 && pageType == 'new'" class="warning-tool">
        审核中，请耐心等待
      </div>
      <div v-if="companyDetailData.auditStatus == 2 && pageType == 'new'" class="danger-tool">
        审核拒绝，原因：{{ companyDetailData.auditReason }}
      </div>
      <span v-if="pageType == 'old'">{{ companyDetailData.auditStatus | auditStatusFileter }}</span>
    </div>
    <!-- 认证表单主体 -->
    <el-form ref="form" :model="formData" :rules="rules" label-width="40px">
      <!-- ============ 认证资料:企业类型 + 证件上传 ============ -->
      <div class="group">
        <div class="top">
          <!-- 企业类型多选(勾选运输类 408 时显示运输许可证上传) -->
          <div class="lines">
            <el-form-item label-width="80px" label="企业类型" prop="companyTypes">
              <el-checkbox-group
                v-model="formData.companyTypes"
                :disabled="!disabled"
                @change="companyTypesChange">
                <el-checkbox v-for="item in firmtypeList" :label="item.dictId" :key="item.dictId">{{
                  item.dictValue
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <!-- 证件上传:法人身份证两面 + 营业执照(均带 OCR 识别回填) -->
          <div class="upload-box">
            <el-form-item prop="idcardBackUrl" label-width="0">
              <MyUpLoad
                v-model="formData.idcardBackUrl"
                name="上传法人身份证人像面"
                type="2"
                validate="idcardBackUrl"
                @ocrIdcardCertificate="changeIdcard"
                :disabled="!disabled" />
            </el-form-item>
            <el-form-item prop="idcardFrontUrl" label-width="0">
              <MyUpLoad
                v-model="formData.idcardFrontUrl"
                name="上传法人身份证国徽面"
                type="1"
                @idcardCertificate="changeIdcards"
                validate="idcardFrontUrl"
                :disabled="!disabled" />
            </el-form-item>
            <el-form-item prop="businessLicenseUrl" label-width="0">
              <!-- 临时下线"仅可更换营业执照"提示气泡,恢复时在 MyUpLoad 上加回 :popVisible="!notSubmitted && disabled" -->
              <MyUpLoad
                v-model="formData.businessLicenseUrl"
                type="3"
                name="上传营业执照"
                validate="businessLicenseUrl"
                @tradingCertificate="changeTrading"
                :disabled="!disabled" />
            </el-form-item>
          </div>
          <!-- 道路运输经营许可证上传(勾选运输类企业类型时显示) -->
          <div>
            <el-form-item prop="roadTransportLicenseUrl" label-width="0">
              <MyUpLoad
                v-show="isRoadTransportLicense"
                v-model="formData.roadTransportLicenseUrl"
                name="上传运输许可证"
                validate="roadTransportLicenseUrl"
                :disabled="!disabled" />
            </el-form-item>
          </div>
          <!-- <div class="entrust">
            <div class="top">
              <p>委托书模板</p>
              <span>预览</span>
              <span>|</span>
              <span class="download">下载</span>
            </div>
            <el-form-item prop="attorneyPowerUrl" label-width="0">
              <el-upload
                action=""
                :before-upload="beforeUpload"
                v-if="!formData.attorneyPowerUrl || !disabled"
              >
                <el-button size="small" type="primary" class="hy-btn"
                  >点击上传委托书</el-button
                >
              </el-upload>
              <div v-if="formData.attorneyPowerUrl && notSubmitted">
                <span>{{ attorneyPowerName }}</span>
                <span @click="formData.attorneyPowerUrl = ''" class="remove"
                  ><i class="el-icon-delete"></i
                ></span>
              </div>
            </el-form-item>
          </div> -->
        </div>
      </div>
      <!-- ============ 认证信息 ============ -->
      <div class="title">认证信息</div>
      <div class="group">
        <!-- 企业名称 / 法人名称 -->
        <div class="line">
          <el-form-item label=" " prop="companyName">
            <el-input
              v-model.trim="formData.companyName"
              placeholder="请输入企业名称"
              maxlength="64"
              prefix-icon="hy-icon-yinhang"
              :disabled="!disabled"></el-input>
            <!-- 临时下线"修改企业名称请联系客服"提示,恢复时取消注释
            <el-popover
              v-if="!notSubmitted && disabled"
              placement="right"
              trigger="hover"
              width="150"
              class="popover-box">
              <div class="custom-content">修改企业名称，请联系客服人员：<br />0902-2305929</div>
              <i slot="reference" class="el-icon-warning-outline" style="font-size: 14px"></i>
            </el-popover>
            -->
          </el-form-item>
          <el-form-item label=" " prop="legalName">
            <el-input
              v-model.trim="formData.legalName"
              placeholder="请输入法人名称"
              maxlength="20"
              prefix-icon="hy-icon-shenfenzheng"
              :disabled="!disabled"></el-input>
          </el-form-item>
        </div>
        <!-- 法人身份证号 / 统一信用代码(修改场景锁定) -->
        <div class="line">
          <el-form-item label=" " prop="legalIdcard">
            <el-input
              v-model="formData.legalIdcard"
              placeholder="请输入法人身份证号"
              prefix-icon="hy-icon-shenfenzheng"
              maxlength="18"
              :disabled="!disabled"></el-input>
          </el-form-item>
          <el-form-item label=" " prop="socialCode">
            <el-input
              v-model="formData.socialCode"
              placeholder="请输入统一信用代码"
              prefix-icon="hy-icon-yinhang"
              maxlength="30"
              :disabled="!notSubmitted"></el-input>
          </el-form-item>
        </div>
        <!-- 法人身份证有效期 + "长期"勾选(二者互斥禁用) -->
        <div class="line">
          <el-form-item label=" " prop="idcardValidityTerm" style="position: relative">
            <span style="position: absolute; left: -21px; top: 3px; color: red">*</span>
            <el-date-picker
              class="date-pick"
              v-model="formData.idcardValidityTerm"
              type="daterange"
              value-format="yyyy.MM.dd"
              range-separator="至"
              start-placeholder="身份证有效期"
              end-placeholder="结束日期"
              :disabled="!disabled || formData.ifLong">
            </el-date-picker>
            <el-form-item label=" " prop="ifLong" class="item-if-long">
              <el-checkbox
                v-model="formData.ifLong"
                :disabled="!disabled || formData.idcardValidityTerm != null"
                >长期</el-checkbox
              >
            </el-form-item>
          </el-form-item>
        </div>
        <!-- 省市区级联 / 详细地址 -->
        <div class="line">
          <el-form-item label=" " prop="region">
            <!-- <span style="position: absolute; left: -21px; top: 3px; color: red">*</span> -->
            <el-cascader
              v-model="formData.region"
              :options="citys"
              placeholder="请选择省/市/区"
              filterable
              clearable
              :props="{
                value: 'name',
                label: 'name',
              }"
              :disabled="!disabled"></el-cascader>
          </el-form-item>
          <el-form-item label=" " prop="address" class="address-input">
            <el-input
              v-model.trim="formData.address"
              prefix-icon="el-icon-location-information"
              maxlength="100"
              placeholder="请输入详细地址"
              :disabled="!disabled"></el-input>
          </el-form-item>
        </div>
        <!-- 电子邮箱 -->
        <div class="line">
          <el-form-item label=" " prop="email">
            <el-input
              v-model.trim="formData.email"
              placeholder="请输入电子邮箱"
              prefix-icon="el-icon-message"
              maxlength="30"
              :disabled="!disabled"></el-input>
          </el-form-item>
        </div>
      </div>
      <!-- ============ 经办人信息 ============ -->
      <div class="title">经办人信息</div>
      <div class="group">
        <!-- 是否法人本人经办单选 -->
        <div class="line">
          <el-form-item label="是否为法人本人" prop="handlerLegalFlag" label-width="150px">
            <el-radio-group v-model="formData.handlerLegalFlag" :disabled="!disabled">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 非法人本人经办:经办人身份证两面上传(带 OCR) -->
        <div v-if="formData.handlerLegalFlag === 0">
          <div class="upload-box padding-content">
            <el-form-item prop="handlerIdcardFrontUrl" label-width="0">
              <MyUpLoad
                v-model="formData.handlerIdcardFrontUrl"
                name="上传经办人身份证人像面"
                type="2"
                validate="handlerIdcardFrontUrl"
                @ocrIdcardCertificate="changehandlerIdcard"
                :disabled="!disabled" />
            </el-form-item>
            <el-form-item prop="handlerIdcardBackUrl" label-width="0">
              <MyUpLoad
                v-model="formData.handlerIdcardBackUrl"
                name="上传经办人身份证国徽面"
                type="1"
                validate="handlerIdcardBackUrl"
                :disabled="!disabled" />
            </el-form-item>
          </div>
          <!-- 经办人姓名 / 身份证号 -->
          <div class="line">
            <el-form-item label=" " prop="handlerName">
              <el-input
                v-model="formData.handlerName"
                placeholder="请输入经办人姓名"
                prefix-icon="hy-icon-yonghuming"
                maxlength="20"
                :disabled="!disabled"></el-input>
            </el-form-item>
            <el-form-item label=" " prop="handlerIdcard">
              <el-input
                v-model="formData.handlerIdcard"
                placeholder="请输入经办人身份证号"
                prefix-icon="hy-icon-shenfenzheng"
                maxlength="18"
                :disabled="!disabled"></el-input>
            </el-form-item>
          </div>
          <!-- 经办人授权书上传 + 模板下载 -->
          <div class="upload-box padding-content">
            <el-form-item prop="handlerLetterAuthorization" label-width="0">
              <MyUpLoad
                v-model="formData.handlerLetterAuthorization"
                name="上传经办人授权书"
                type=""
                validate="handlerLetterAuthorization"
                :disabled="!disabled" />
              <div class="author-download" v-if="disabled">
                授权书模板
                <el-button type="text" @click="handleAuthorizationDownload">下载</el-button>
              </div>
            </el-form-item>
          </div>
        </div>
        <!-- 法人本人经办:手持身份证照片上传 + 示例查看 -->
        <div v-if="formData.handlerLegalFlag == 1">
          <div class="upload-box padding-content">
            <el-form-item prop="handlerLegalPhotoUrl" label-width="0">
              <MyUpLoad
                v-model="formData.handlerLegalPhotoUrl"
                name="上传法人手持身份证照片"
                type=""
                validate="handlerLegalPhotoUrl"
                :disabled="!disabled" />
              <div class="author-download" v-if="disabled">
                <el-button type="text" @click="handleLegalPersonIdCard">示例</el-button>
              </div>
            </el-form-item>
          </div>
        </div>
      </div>
      <!-- 首次认证/重新认证底部:协议勾选 + 提交认证 -->
      <div class="bottom" v-if="notSubmitted">
        <div class="checked">
          <el-checkbox v-model="radio" :label="true">&nbsp;</el-checkbox>
          <p>
            已阅读并同意<span @click="user = true" class="agreement"
              >《新疆煤炭交易中心交易商认证协议》</span
            >
          </p>
        </div>
        <div class="btn-wrap">
          <el-button @click="submit" class="hy-btn" :disabled="!radio" :loading="submiting"
            >提交认证</el-button
          >
        </div>
        <div class="tip">认证成功后,当前申请账号将自动成为企业管理员账号！</div>
      </div>
      <!-- 已认证底部:修改账户信息 / 重新认证 / 确认修改 -->
      <div v-else>
        <!-- <div class="bottom" v-if="formData.auditStatus == 0">
          <div class="tip">审核通过后才可修改收款账号</div>
        </div> -->
        <div
          class="bottom"
          v-if="
            !pageLoading &&
            userId == formData.enterpriseId &&
            (formData.auditStatus == 1 || formData.auditStatus == 2)
          ">
          <div class="btn-wrap" v-if="!disabled">
            <!-- 当前已存在未审核通过的申请，不允许修改 -->
            <el-button
              @click="edit"
              v-if="formData.auditStatus == 1 && lastApplyStatus !== 0 && lastApplyStatus !== 2"
              >修改账户信息</el-button
            >
            <el-button v-if="formData.auditStatus == 2" @click="recertification"
              >重新认证</el-button
            >
          </div>
          <div class="btn-wrap" v-else>
            <el-button @click="submitedit" :loading="submiting">确认修改</el-button>
          </div>
        </div>
      </div>
    </el-form>
    <!-- 交易商认证协议弹窗 -->
    <EnterpriseAgreementDlg :visible.sync="user" />
    <!-- 提交成功提示弹窗 -->
    <message :visible.sync="mssagevisible" />
    <!-- 图片预览(手持身份证示例) -->
    <PreviewImage ref="previewImageRef" :isLocal="true" />
  </div>
</template>

<script>
// function insertStr(soure, start, newStr) {
//   return soure.slice(0, start) + newStr + soure.slice(start);
// }
import { getbannerList } from "@/api/home";
import {
  reqCompanyAuthDetail,
  reqApplyCompanyAuthDetail,
  reqAddAuth,
  reqEditAuthCompany,
  getSysDictDataByByDictType,
  // reqUploadfile,
  systemSysList,
} from "@/api/hy";
import { getCompanyAuthDetail } from "@/api/userCenters.js";
import url from "@/api/url/hy_url";
import Vue from "vue";
import * as types from "@/store/action-types";
import { downFile } from "@/utils/toolset.js";
import { getTreeV2 } from "@/api/Medium.js";
const { baseUrl } = require("@/config");

export default {
  data() {
    /** 姓名校验:2-20 位汉字(可含间隔号·),用于法人/经办人姓名 */
    const validateLegerName = (rule, value, callback) => {
      let validate = /^[\u4e00-\u9fa5·]{2,20}$/;
      if (!validate.test(value)) {
        return callback(new Error("请输入2-20位汉字"));
      } else {
        return callback();
      }
    };
    /** 省市区校验:必填(首次认证与修改场景均校验) */
    // const validateRegion = (rule, value, callback) => {
    //   if (value?.length > 0) {
    //     return callback();
    //   } else {
    //     return callback(new Error("请选择省/市/区"));
    //   }
    // };
    return {
      /** 接口基础地址(拼接文件访问路径) */
      baseUrl: baseUrl,
      /** 文件基础地址(授权书模板下载用) */
      fileBaseUrl: baseUrl + url.getFileUrl,
      /** 省市区级联数据源 */
      citys: [],
      /** 提交成功提示弹窗开关 */
      mssagevisible: false,
      /** 企业类型选项列表(company_type 字典) */
      firmtypeList: [],
      /** 银行名模糊搜索选项(当前表单未使用) */
      options: [],
      /** 模糊搜索加载状态(当前表单未使用) */
      loading: false,
      /** 当前登录用户 ID */
      userId: Vue.ls.get(types.userId),
      /** 表单数据 */
      formData: {
        /** 企业 ID */
        enterpriseId: Vue.ls.get(types.enterpriseId),
        /** 法人身份证国徽面地址 */
        idcardFrontUrl: "",
        /** 法人身份证人像面地址 */
        idcardBackUrl: "",
        /** 营业执照地址 */
        businessLicenseUrl: "",
        /** 道路运输经营许可证地址 */
        roadTransportLicenseUrl: "",
        /** 法人姓名 */
        legalName: "",
        /** 企业名称 */
        companyName: "",
        /** 法人身份证号 */
        legalIdcard: "",
        /** 统一信用代码(仅首次认证可填,修改场景锁定) */
        socialCode: "",
        /** 法人身份证有效期(起止日期数组) */
        idcardValidityTerm: null,
        /** 收款账号(当前表单未使用) */
        // accountNumber: "",
        /** 收款户名(当前表单未使用) */
        // accountName: "",
        /** 收款银行(当前表单未使用) */
        // accountBank: "",
        // attorneyPowerUrl: "",
        /** 审核状态 */
        auditStatus: null,
        /** 身份证是否长期有效 */
        ifLong: false,
        /** 企业类型(字典 id 集合) */
        companyTypes: [],
        /** 省市区 */
        region: [],
        /** 详细地址 */
        address: "",
        /** 经办人身份证人像面 */
        handlerIdcardFrontUrl: "",
        /** 经办人身份证国徽面 */
        handlerIdcardBackUrl: "",
        /** 经办人姓名 */
        handlerName: "",
        /** 经办人身份证号 */
        handlerIdcard: "",
        /** 经办人授权书地址 */
        handlerLetterAuthorization: "",
        /** 是否法人本人 0否 1是 */
        handlerLegalFlag: 0,
        /** 法人手持身份证照片 */
        handlerLegalPhotoUrl: "",
      },
      /** 表单校验规则 */
      rules: {
        legalName: [
          { required: true, message: "请输入法人名称", trigger: ["blur", "change"] },
          { validator: validateLegerName, trigger: "blur" },
        ],
        idcardFrontUrl: [
          {
            required: true,
            message: "请上传法人身份证国徽面",
            trigger: "change",
          },
        ],
        region: [{ required: true, message: "请选择省/市/区", trigger: "change" }],
        email: [
          {
            required: true,
            message: "请输入电子邮箱",
            trigger: ["blur", "change"],
          },
        ],
        idcardBackUrl: [
          {
            required: true,
            message: "请上传法人身份证人像面",
            trigger: "change",
          },
        ],
        businessLicenseUrl: [{ required: true, message: "请上传营业执照", trigger: "change" }],
        companyName: [
          { required: true, message: "请填写企业名称", trigger: ["blur", "change"] },
          {
            min: 1,
            max: 99,
            message: "长度在 1 到 99 个字符",
            trigger: "blur",
          },
        ],
        legalIdcard: [
          { required: true, message: "请填写法人身份证号", trigger: ["blur", "change"] },

          {
            pattern:
              /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/,
            message: "请输入有效身份证号码",
            trigger: "blur",
          },
        ],
        socialCode: [
          { required: true, message: "请填写统一信用代码", trigger: ["blur", "change"] },
          {
            pattern: /^[A-Za-z0-9]{1,30}$/,
            message: "请输入有效统一信用代码",
            trigger: "blur",
          },
          { min: 1, max: 30, trigger: "blur" },
        ],

        /** 收款账号(当前表单未使用,仅保留校验) */
        // accountNumber: [
        //   { required: false, message: "请填写收款账号", trigger: ["blur", "change"] },
        //   {
        //     pattern: /^[0-9]{1,30}/,
        //     message: "请输入有效收款账号",
        //     trigger: "blur",
        //   },
        //   { min: 1, max: 30, trigger: "blur" },
        // ],
        // accountName: [
        //   { required: false, message: "请填写收款户名", trigger: ["blur", "change"] },
        //   {
        //     pattern: /^[\u4E00-\u9FA5]{1,30}$/,
        //     message: "请输入正确收款户名",
        //     trigger: "blur",
        //   },
        //   { min: 1, max: 30, trigger: "blur" },
        // ],
        // accountBank: [{ required: false, message: "请填写收款银行", trigger: ["blur", "change"] }],
        // attorneyPowerUrl: [{ required: true, message: "请上传委托书", trigger: "change" }],
        companyTypes: [{ required: true, message: "请选择企业类型", trigger: "change" }],
        address: [{ required: true, message: "请填写住所详细地址", trigger: ["blur", "change"] }],
        handlerIdcardFrontUrl: [
          {
            required: true,
            message: "请上传经办人身份证人像面",
            trigger: "change",
          },
        ],
        handlerIdcardBackUrl: [
          {
            required: true,
            message: "请上传经办人身份证国徽面",
            trigger: "change",
          },
        ],
        handlerName: [
          { required: true, message: "请填写经办人姓名", trigger: "blur" },
          { validator: validateLegerName, trigger: "blur" },
        ],
        handlerIdcard: [
          { required: true, message: "请填写经办人身份证号", trigger: "blur" },
          {
            pattern:
              /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/,
            message: "请输入有效身份证号码",
            trigger: "blur",
          },
        ],
        handlerLetterAuthorization: [
          { required: true, message: "请上传经办人授权书", trigger: "change" },
        ],
        handlerLegalFlag: [
          { required: true, message: "请选择是否为法人本人经办", trigger: "blur" },
        ],
        handlerLegalPhotoUrl: [
          { required: true, message: "请上传法人手持身份证照片", trigger: "change" },
        ],
      },
      /** 企业认证协议勾选状态 */
      radio: false,
      // attorneyPowerName: "",
      /** 提交按钮状态 */
      submiting: false,
      /** 是否为未提交认证  且  不能再次修改的企业信息  （true = 首次认证 / 拒绝后重新认证）：edit 模式下为 false */
      notSubmitted: false,
      /** 是否为未提交认证  且  可以进行修改的企业信息  （名字反的，true = 可编辑）：首次认证(-1)、点「修改账户信息」edit()、点「重新认证」recertification() 时为 true。 */
      disabled: false,
      /** 查看企业认证协议弹窗开关 */
      user: false,
      /** 是否是修改后重新认证 */
      isagin: false,
      /** 是否显示道路运输经营许可证上传字段 */
      isRoadTransportLicense: false,
      /** 初始企业详情数据 */
      companyDetailData: {},
      /** 页面类型 old 首次或已认证通过信息 new 最新提交未审核通过的信息  */
      pageType: "old",
      /** 最后一次更新状态 */
      lastApplyStatus: "",
      /** 整页loading:mounted 初始接口全部请求完成后关闭(同时作为已认证底部按钮的渲染闸门) */
      pageLoading: true,
    };
  },
  filters: {
    /** 审核状态码转文案:-1 未提交认证,0 审核中,1 已通过,2 已拒绝 */
    auditStatusFileter(val) {
      return {
        "-1": "未提交认证",
        0: "审核中",
        1: "已通过",
        2: "已拒绝",
      }[val];
    },
  },
  // computed: {
  //   /** 控制省市区是否禁用 */
  //   isRegionDisabled() {
  //     /** 未提交认证 */
  //     if (this.companyDetailData.auditStatus == -1) return false;
  //     /** 修改账户信息或需要重新认证 */
  //     if (this.disabled) {
  //       console.log("companyDetailData.region", this.companyDetailData.region);
  //       if (this.companyDetailData.region) return true;
  //       else return false;
  //     } else {
  //       return true;
  //     }
  //   },
  // },
  components: {
    /** 证件图片上传组件(带 OCR 识别回传) */
    MyUpLoad: () => import("./components/MyUpLoad.vue"),
    /** 提交成功提示弹窗 */
    message: () => import("./components/message.vue"),
    /** 本地图片预览 */
    PreviewImage: () => import("@/components/PreviewImg.vue"),
    /** 交易商认证协议弹窗 */
    EnterpriseAgreementDlg: () => import("./components/EnterpriseAgreementDlg.vue"),
  },
  /** 初始化:读路由页面类型,串行加载省市区树/企业认证详情(含最新申请状态/企业类型字典)/银行字典,全部完成后关整页loading */
  async mounted() {
    this.pageType = this.$route.query?.type || "old";
    try {
      await this.getTree().catch(() => {});
      await this.getCompanyDetail().catch(() => {});
      await this.handleSelect().catch(() => {});
    } finally {
      this.pageLoading = false;
    }
  },
  methods: {
    /** 查看法人手持身份证示例图片 */
    handleLegalPersonIdCard() {
      this.$refs.previewImageRef.open("sample.png");
    },
    /** 授权书模板下载 */
    handleAuthorizationDownload() {
      let dictType = "authorization_letter";
      systemSysList(dictType).then(res => {
        if (res.code == 0) {
          downFile(this.fileBaseUrl + res.data[0].dictValue, res.data[0].dictLabel);
        }
      });
    },
    /** 获取省市区树数据 */
    getTree() {
      return getTreeV2().then(res => {
        if (res.code == 0) {
          this.citys = this.deleteChildren(res.data);
        }
      });
    },
    /** 递归删除树数据的空 children 节点(级联不显示空层级) */
    deleteChildren(arr) {
      let childs = arr;
      for (let i = childs?.length; i--; i > 0) {
        if (childs[i].children) {
          if (childs[i].children?.length) {
            this.deleteChildren(childs[i].children);
          } else {
            delete childs[i].children;
          }
        }
      }
      return arr;
    },
    /** 企业类型勾选变化:含运输类(408)时显示运输许可证上传 */
    companyTypesChange(e) {
      console.log(e);
      let list = e;
      if (list.length > 0) {
        if (list.includes("408")) {
          this.isRoadTransportLicense = true;
        } else {
          this.isRoadTransportLicense = false;
        }
      } else {
        this.isRoadTransportLicense = false;
      }
    },
    /** 获取企业类型字典(全量),并按已选类型回显运输许可证入口 */
    async getFirmtype() {
      const obj = {
        pageNum: 1,
        pageSize: 1000,
        dictType: "company_type",
      };
      const res = await getbannerList(obj);
      if (res.code == 0) {
        console.log("企业类型字典", res.data.list);
        /** 企业类型放开修改,统一返回全量列表(原先已认证场景只展示已选类型) */
        this.firmtypeList = res.data.list;
        /** 按已选类型回显运输许可证上传入口 */
        let selected = this.formData.companyTypes || [];
        this.isRoadTransportLicense = selected.includes("408");
      }
    },
    /** 识别营业执照信息(所有可编辑状态均可回填;统一信用代码只有首次认证时或者首次认证失败时才可更换) */
    changeTrading(data) {
      if (
        this.formData.socialCode == data.code ||
        this.companyDetailData.auditStatus == -1 ||
        (this.companyDetailData.auditStatus == 2 && this.pageType == "old")
      ) {
        /** 旧地址非空且与识别结果不同时,同步清空省市区,强制按新地址重选 */
        if (this.formData.address && this.formData.address != data.address) {
          this.formData.region = [];
        }
        this.formData.address = data.address;
        this.formData.companyName = data.name;
        this.formData.legalName = data.owner;
        this.formData.socialCode = data.code;
      } else {
        this.$message.error("营业执照信息不匹配，统一社会信用代码不一致，请核对后重新上传");
      }
    },
    /** 识别法人身份证国徽面:回填证件有效期 */
    changeIdcards(data) {
      let arr = data?.timelimit?.split("-") || null;
      this.formData.idcardValidityTerm = arr;
    },
    /** 识别法人身份证正面图片信息 */
    changeIdcard(data) {
      this.formData.legalIdcard = data.number;
      this.formData.legalName = data.name;
    },
    /** 识别经办人身份证正面图片信息 */
    changehandlerIdcard(data) {
      this.formData.handlerName = data.name;
      this.formData.handlerIdcard = data.number;
    },
    /** 银行名远程模糊搜索(当前表单未使用) */
    remoteMethod(query) {
      // 如果用户输入内容了，就发请求拿数据，远程搜索模糊查询
      if (query !== "") {
        this.loading = true; // 开始拿数据喽
        // 这里模拟发请求，res就当成发请求返回来的数据吧。
        let config = {
          dictType: "bank_name",
          pageNum: 1,
          pageSize: 10000000,
          searchParam: query,
        };
        getSysDictDataByByDictType(config).then(ret => {
          if (ret.code == 0) {
            let res = ret.data.list;
            this.loading = false; //
            // 然后把拿到的所有数据，首先进行一个过滤，把有关联的过滤成一个新数组给到options使用
            this.options = res.filter(item => {
              // indexOf等于0代表只要首个字匹配的，如：搜索 王 王小虎数据会被过滤出来，但是 小虎王的数据不会被过滤出来。因为indexOf等于0代表以什么开头
              // return item.label.toLowerCase().indexOf(query.toLowerCase()) == 0

              // indexOf大于-1代表的是，只要有这个字出现的即可，如：搜索 王 王小虎、小虎王、小王虎都会被过滤出来。因为indexOf找不到才会返回-1，
              // 大于-1说明只要有就行，不论是不是开头也好，中间也好，或者结尾也好
              return item.dictValue.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
          }
        });
      } else {
        this.options = [];
      }
    },

    /** 拉取银行名字典列表(当前表单未使用) */
    handleSelect(e) {
      let config = {
        dictType: "bank_name",
        pageNum: 1,
        pageSize: 10000000,
        searchParam: e ? e : "",
      };
      return getSysDictDataByByDictType(config).then(res => {
        if (res.code == 0) {
          this.options = res.data.list;
        }
      });
    },
    /** 回填收款账号(当前表单未使用) */
    // formDataaCcountNumber(e) {
    //   this.formData.accountNumber = e;
    // },
    /** 重新认证:开启编辑;回填"是否法人本人";pageType=new 走修改提交,否则走首次提交 */
    recertification() {
      // 步骤一:进入可编辑状态
      this.disabled = true;
      // 步骤二:老数据无经办人标记时默认"否"
      if (
        this.companyDetailData.handlerLegalFlag !== 0 &&
        this.companyDetailData.handlerLegalFlag !== 1
      ) {
        this.formData.handlerLegalFlag = 0;
      } else {
        this.formData.handlerLegalFlag = this.companyDetailData.handlerLegalFlag;
      }
      // 步骤三:查看最新申请(new)时走"确认修改",否则按首次认证流程提交
      if (this.pageType == "new") {
        this.isagin = true;
        this.notSubmitted = false;
      } else {
        this.notSubmitted = true;
      }
    },
    /** 修改账户信息:开启编辑(老数据无经办人标记时默认"否") */
    edit() {
      this.disabled = true;
      if (
        this.companyDetailData.handlerLegalFlag !== 0 &&
        this.companyDetailData.handlerLegalFlag !== 1
      ) {
        this.formData.handlerLegalFlag = 0;
      }
    },
    /** 获取企业认证信息:按 pageType 取"最新申请"或"已认证"详情,并初始化页面状态 */
    async getCompanyDetail() {
      try {
        let ret;
        let enterpriseId = Vue.ls.get(types.enterpriseId);
        if (this.pageType == "new") {
          ret = await reqApplyCompanyAuthDetail({ enterpriseId });
        } else {
          ret = await reqCompanyAuthDetail({ enterpriseId });
        }
        if (ret.code == 0) {
          // 步骤一:重置状态并快照原始详情
          this.isagin = false;
          this.notSubmitted = false;
          ret.data.companyTypes = ret.data.companyTypes || [];
          this.companyDetailData = JSON.parse(JSON.stringify(ret.data));
          console.log("this.companyDetailData", this.companyDetailData);
          /** auditStatus:审核状态(-1:未提交认证,0:待审核,1:审核通过,2:审核拒绝) */
          if (ret.data.auditStatus == -1) {
            this.notSubmitted = true;
            this.disabled = true;
          } else {
            // 步骤二:已通过时查最新申请状态(控制"修改账户信息"按钮显隐),await 确保按钮显隐判断前状态就绪
            if (ret.data.auditStatus == 1) {
              await this.getCompanyAuthDetail();
            }
            this.bindData(ret.data);
            this.setDisabled(ret.data);
            if (ret.data.auditStatus == 2) {
              this.recertification();
            }
          }
        } else {
          this.notSubmitted = true;
        }
      } finally {
        // 详情与最新申请状态全部就绪(或请求异常)后,再串行加载企业类型字典(依赖已绑定的表单数据)
        await this.getFirmtype();
      }
    },
    /** 获取最新审核状态 */
    getCompanyAuthDetail() {
      return getCompanyAuthDetail().then(res => {
        if (res.code == 0) {
          this.lastApplyStatus = res.data.lastApplyStatus;
          console.log("lastApplyStatus", this.lastApplyStatus);
          // if (this.lastApplyStatus == 2) {
          //   this.disabled = true;
          // }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /** 按审核状态设置可编辑性(disabled=true 表示可编辑) */
    setDisabled(item) {
      /** 非已通过状态默认可编辑 */
      this.disabled = item.auditStatus != 1;
      /** 审核中:只读查看 */
      if (item.auditStatus == 0) {
        this.disabled = false;
      }
      if (item.auditStatus == 2) {
        this.disabled = false;
      }
    },
    /** 详情数据回填表单:省市区字符串转数组,有效期字符串转数组 */
    bindData(data) {
      this.formData = data;
      this.formData.region = data.region?.split(",") || [];
      // console.log("getCompanyDetail", this.formData);
      if (data.idcardValidityTerm != null && data.idcardValidityTerm != "") {
        try {
          this.formData.idcardValidityTerm = data.idcardValidityTerm.split("-");
        } catch (e) {
          console.log(e);
        }
      } else {
        this.formData.idcardValidityTerm = null;
      }
      // console.log("getCompanyDetail", this.formData);
    },
    /** 提交认证入口:需勾选协议,整体校验通过后提交 */
    submit() {
      // if (!this.companyDetailData.region) return this.message.error("请选择省市区");
      if (!this.isEdit && !this.radio) return;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitFn();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 修改企业认证信息:校验通过后提交,成功弹提示并切回只读 */
    submitedit() {
      // if (!this.companyDetailData.region) {
      //   this.$refs.form.clearValidate("region");
      // }
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submiting = true;
          let data = this.initSubmitData();
          // console.log("修改提交数据", data);
          try {
            /** 修改企业认证信息 */
            let res = await reqEditAuthCompany(data);
            if (res.code == 0) {
              this.mssagevisible = true;
              this.disabled = !this.disabled;
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
            this.submiting = false;
          } catch (err) {
            console.log(err);
            this.submiting = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 组装提交数据:省市区数组转逗号字符串,有效期数组转"起-止"字符串 */
    initSubmitData() {
      // this.formData.auditStatus = 0;
      let data = {
        ...this.formData,
        region: this.formData.region?.join(","),
      };
      if (data.idcardValidityTerm != null && data.idcardValidityTerm != "") {
        try {
          data.idcardValidityTerm = data.idcardValidityTerm.join("-");
        } catch (e) {
          e;
        }
      } else {
        data.idcardValidityTerm = null;
      }
      // 法人本人经办:经办人信息及授权书不提交(仅清空提交副本,页面字段保留,切换开关值仍在)
      if (data.handlerLegalFlag == 1) {
        data.handlerName = "";
        data.handlerIdcard = "";
        data.handlerIdcardFrontUrl = "";
        data.handlerIdcardBackUrl = "";
        data.handlerLetterAuthorization = "";
      } else {
        // 非法人本人经办:法人手持身份证照不提交
        data.handlerLegalPhotoUrl = "";
      }
      // 企业类型未勾选物流服务商(408):道路运输经营许可证不提交
      if (!data.companyTypes?.includes("408")) {
        data.roadTransportLicenseUrl = "";
      }
      return data;
    },
    /** 提交认证:防重复提交;企业名称半角括号转全角;成功弹提示 3 秒后回首页 */
    submitFn() {
      // 步骤一:防重复提交并组装数据
      if (this.submiting) return;
      this.submiting = true;
      let data = this.initSubmitData();
      data.companyName = data.companyName?.replace(/\(/g, "（").replace(/\)/g, "）");
      // console.log("提交数据", data);
      // 步骤二:提交,成功弹提示并 3 秒后回首页
      reqAddAuth(data)
        .then(ret => {
          if (ret.code == 0) {
            this.mssagevisible = true;
            setTimeout(() => {
              this.$router.push({
                path: "/index",
              });
            }, 3000);
          } else {
            this.$message({
              type: "error",
              message: ret.message,
            });
          }
          this.submiting = false;
        })
        .catch(err => {
          console.log(err);
          this.submiting = false;
        });
    },
    // beforeUpload(file) {
    //   this.attorneyPowerName = file.name;
    //   reqUploadfile(file)
    //     .then(ret => {
    //       if (ret.code == 0) {
    //         this.formData.attorneyPowerUrl = ret.data;
    //       }
    //     })
    //     // eslint-disable-next-line no-unused-vars
    //     .catch(err => {});
    //   return false;
    // },
  },
};
</script>

<style lang="scss" scoped>
/* 校验错误提示拉长宽度(表单项为双列布局,避免提示文字被挤压) */
::v-deep .el-form-item__error {
  min-width: 800px;
}
/* 日期范围分隔符样式 */
.el-range-separator {
  border: 1px solid blue;
}
/* 页面容器:定宽居中白底 */
.authentication {
  width: 1195px;
  margin: 15px auto;
  background: white;
  &::before,
  &::after {
    display: table;
    content: "";
  }
}
/* 审核状态提示区 */
.state-box {
  margin: 20px;
  /* 审核中:橙色警告条 */
  .warning-tool {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    background-color: rgba(230, 162, 60, 0.1);
    border: 1px solid #e6a23c;
    color: #e6a23c;
  }
  /* 审核拒绝:红色提示条 */
  .danger-tool {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    background-color: rgba(255, 0, 0, 0.1);
    border: 1px solid red;
    color: red;
  }
  /* 状态文案 */
  span {
    text-align: right;
    display: block;
    // color: green;
  }
}
/* 委托书区块(模板已注释停用) */
.entrust {
  .top {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    p {
      margin-right: 40px;
      color: #2084d6;
    }
    span {
      cursor: pointer;
      & + span {
        margin-left: 5px;
      }
    }
  }
}
/* 分组标题栏:灰底加粗,红色角标 */
.title {
  font-size: 18px;
  font-weight: bold;
  font-family: PingFang SC;
  padding: 14px 15px;
  border: 1px solid #e5e5e5;
  border-left: none;
  border-right: none;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  span {
    margin-left: 5px;
    color: red;
    font-weight: normal;
  }
}
/* 证件上传区:横向排列两端对齐 */
.upload-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 经办人上传区左右留白 */
.padding-content {
  padding: 0 140px;
}
/* 底部操作区:协议勾选+按钮行 */
.bottom {
  text-align: center;
  margin-bottom: 40px;
  /* 协议勾选行 */
  .checked {
    display: flex;
    align-items: center;
    justify-content: center;
    &::v-deep .el-radio {
      margin-right: 0;
    }
  }
  /* 操作按钮行 */
  .btn-wrap {
    margin: 25px 0 18px 0;
    .el-button {
      width: 200px;
    }
  }
  /* 红色提示文案 */
  .tip {
    color: red;
  }
}
/* 删除图标(委托书区块,已停用) */
.remove {
  cursor: pointer;
  margin-left: 10px;
  vertical-align: middle;
}
/* 表单分组容器 */
.group {
  padding: 32px;
  background: white;
}
/* 表单行:双列布局,输入框统一宽度 */
.line {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 80px;

  ::v-deep .el-input,
  .el-date-editor {
    width: 360px !important;
  }

  /* "长期"勾选定位在日期选择器右侧 */
  .item-if-long {
    position: absolute;
    top: 0;
    right: -90px;
  }
}
/* 委托书上传按钮缩进(已停用) */
.entrust {
  margin-left: 104px;
  .hy-btn {
    width: 163px;
  }
}
/* 下载/协议链接样式 */
.download,
.agreement {
  cursor: pointer;
  color: #3889fb;
}
/* 企业类型行 */
.lines {
  display: flex;
  justify-content: space-between;
}
/* 授权书模板下载/示例按钮定位 */
.author-download {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 10px);
}
/* 营业执照"仅可更换"提示气泡(当前已注释停用) */
.popover-box {
  margin-left: 5px;
  .el-icon-warning-outline {
    font-size: 18px !important;
    color: #7b7575;
  }
}
</style>
